export default class FakeMoment {
  format() {
    return '';
  }
}
